import styled from 'styled-components'
import {
  CORRECT_COLOR,
  INCORRECT_COLOR,
} from '~/pages/anatomyV2/libs/components/MultipleChoiceQuestionTemplate/constants'
import {
  anatomyV2ContentWrapperCss,
  anatomyV2RootCss,
} from '~/pages/anatomyV2/libs/pageLayoutStyles'
import { Button } from '~/shared/components/Button'
import { COLORS } from '~/shared/constants/uiConstants'

export const MultipleChoiceQuestionTemplateStyles = {
  Root: styled.div`
    ${anatomyV2RootCss}
    overflow: hidden;
  `,

  ContentWrapper: styled.div`
    ${anatomyV2ContentWrapperCss}
    min-height: 0;
    padding: 16px;
    overflow-y: auto;
  `,

  Title: styled.h1`
    font-size: 22px;
    font-weight: 700;
    line-height: 1.1;
    color: ${COLORS.BLACK};
    margin: 24px 0 16px;
  `,

  Grid: styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
    margin-top: auto;
  `,

  OptionCard: styled.button`
    position: relative;
    background: ${COLORS.WHITE};
    border: none;
    border-radius: 14px;
    overflow: hidden;
    cursor: pointer;
    padding: 16px 16px 8px;
    text-align: center;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    touch-action: manipulation;

    &:active {
      background: ${COLORS.WHITE};
    }
  `,

  CardImage: styled.div`
    width: 100%;

    img {
      width: 100%;
      height: 106px;
      display: block;
      border-radius: 8px;
      object-fit: cover;
    }
  `,

  CardLabel: styled.p`
    margin-top: 16px;
    color: #000;
    font-family: 'Mulish', sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 1;
  `,

  ResultContent: styled.div`
    width: 100%;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: safe center;
  `,

  ResultCard: styled.div<{ $isCorrect: boolean }>`
    width: 100%;
    border-radius: 12px;
    border: 1px solid
      ${({ $isCorrect }) => ($isCorrect ? CORRECT_COLOR : INCORRECT_COLOR)};
    background: ${COLORS.WHITE};
    padding: 50px 30px;
    text-align: center;
  `,

  ResultMascot: styled.img`
    display: block;
    max-width: 136px;
    margin: 0 auto 20px;
  `,

  ResultTitle: styled.p<{ $isCorrect: boolean }>`
    margin-bottom: 10px;
    font-family: 'Mulish', sans-serif;
    font-size: 22px;
    font-weight: 700;
    line-height: 1;
    color: ${({ $isCorrect }) =>
      $isCorrect ? CORRECT_COLOR : INCORRECT_COLOR};
  `,

  ResultExplanation: styled.p`
    color: ${COLORS.BLACK};
    font-family: 'Mulish', sans-serif;
    font-size: 15px;
    font-weight: 500;
  `,

  StyledButton: styled(Button)`
    width: 100%;
    margin-top: 16px;
  `,
}
